import fetch, { wymsFetch } from '@/utils/fetch';

// 统一处理请求参数
export const filterURLSearchParams = (args = {}) => {
    const params = new URLSearchParams();
    Object.keys(args).forEach(key => {
        params.append(key, args[key]);
    })
    return params;
}

// 查询区域
export const listAreaByParentCode = params =>
    wymsFetch({
        url: 'school/listAreaByParentCode',
        method: 'GET',
        params: filterURLSearchParams(params)
    })

// 查询套件列表
export const querySuiteList = params =>
    wymsFetch({
        url: 'statisticsWY/querySuiteList',
        method: 'GET',
        params: filterURLSearchParams(params)
    })

// 套件安装详情
export const querySuiteSchoolList = params =>
    wymsFetch({
        url: 'statisticsWY/querySuiteSchoolList',
        method: 'GET',
        params: filterURLSearchParams(params)
    })

// 套件安装详情
export const getModuleCreCountBySchIdAndDateScope = params =>
    fetch({
        url: 'structure/modulestatistics/getModuleCreCountBySchIdAndDateScope',
        method: 'GET',
        params: filterURLSearchParams(params)
    })


// WEBPACK FOOTER //
// ./src/api/kitDataStatistics.js